import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPlus, FaMinus } from 'react-icons/fa';
import API from '../api/axios';

const FAQSection = () => {
  const [faqs, setFaqs] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    API.get('/faq').then(r => setFaqs(r.data)).catch(() => {
      setFaqs([
        { _id: '1', question: 'What services do you offer?', answer: 'I offer Full Stack Web Development (MERN Stack), WordPress Development, E-Commerce Solutions, and comprehensive SEO services including On-Page, Off-Page, and Technical SEO.' },
        { _id: '2', question: 'How long does a typical project take?', answer: 'Project timelines vary based on complexity. A simple website takes 3-7 days, while complex web applications may take 2-4 weeks. I always provide a clear timeline before starting.' },
        { _id: '3', question: 'What is your payment process?', answer: 'I accept payments via bKash, Nagad, and Cryptocurrency (USDT). Payment is required after order confirmation, and you can track your order progress through the dashboard.' },
        { _id: '4', question: 'Do you provide post-delivery support?', answer: 'Yes! I offer free support for bug fixes and minor adjustments after delivery. For ongoing maintenance, I have affordable monthly plans.' }
      ]);
    });
  }, []);

  if (faqs.length === 0) return null;

  return (
    <section className="faq section" id="faq">
      <div className="container" style={{ maxWidth: '800px' }}>
        <div className="section-title"><h2>FAQ</h2><p>Frequently asked questions</p></div>
        <div className="faq-list">
          {faqs.map((faq, idx) => (
            <motion.div key={faq._id} className={`faq-item ${active === idx ? 'active' : ''}`}
              initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ delay: idx * 0.1 }}>
              <button className="faq-question" onClick={() => setActive(active === idx ? null : idx)}>
                <span>{faq.question}</span>
                {active === idx ? <FaMinus /> : <FaPlus />}
              </button>
              <AnimatePresence>
                {active === idx && (
                  <motion.div className="faq-answer" initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.3 }}>
                    <p>{faq.answer}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
